import { useState } from "react";
import Layout from "../Layouts/Layout.jsx";
import { formatDistanceToNow } from "date-fns";
import useSessionStore from "../stores/sessionStore";
import authProvider from "../authProvider";
import Button from "../components/ui/Button.jsx";

export default function Profile() {
  const user = useSessionStore((state) => state.user);
  const [confirming, setConfirming] = useState(false);
  const [signingOut, setSigningOut] = useState(false);
  const [signOutError, setSignOutError] = useState(null);

  const signOutEverywhere = async () => {
    setSigningOut(true);
    setSignOutError(null);
    const result = await authProvider.logout({ everywhere: true });
    // On success the auth listener clears the user and this page unmounts.
    if (!result.success) {
      setSignOutError("Could not sign out everywhere. Please try again.");
      setSigningOut(false);
      setConfirming(false);
    }
  };

  return (
    <Layout title="Your Profile">
      <div className="container w-full rounded-xl bg-white dark:bg-gray-800 shadow p-4 min-h-40">
        <div className="mt-0 border-b border-gray-100 dark:border-gray-700">
          <dl className="divide-y divide-gray-100 dark:divide-gray-700">
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
              <dt className="text-sm/6 font-medium text-gray-900 dark:text-gray-100">Email</dt>
              <dd className="mt-1 text-sm/6 text-gray-700 dark:text-gray-200 sm:col-span-2 sm:mt-0">{user.email}</dd>
            </div>
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
              <dt className="text-sm/6 font-medium text-gray-900 dark:text-gray-100">Last sign in</dt>
              <dd className="mt-1 text-sm/6 text-gray-700 dark:text-gray-200 sm:col-span-2 sm:mt-0">
                {formatDistanceToNow(new Date(user.last_sign_in_at), { addSuffix: true })}
              </dd>
            </div>
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
              <dt className="text-sm/6 font-medium text-gray-900 dark:text-gray-100">Role</dt>
              <dd className="mt-1 text-sm/6 text-gray-700 dark:text-gray-200 sm:col-span-2 sm:mt-0">{user.profile.role}</dd>
            </div>
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
              <dt className="text-sm/6 font-medium text-gray-900 dark:text-gray-100">Team Name</dt>
              <dd className="mt-1 text-sm/6 text-gray-700 dark:text-gray-200 sm:col-span-2 sm:mt-0">{user.profile.team_name}</dd>
            </div>
          </dl>
        </div>
        <div className="px-4 py-6 sm:px-0">
          <h3 className="text-sm/6 font-medium text-gray-900 dark:text-gray-100">Sign out everywhere</h3>
          <p className="mt-1 text-sm/6 text-gray-700 dark:text-gray-200">
            Signs you out here and stops your other devices and browsers from signing in again or
            refreshing their login. A device that is already signed in may keep working for a
            while before it is asked to sign in again. Changing your password is also a good idea
            if you think someone else has access.
          </p>
          {signOutError && <p className="mt-2 text-sm text-red-500">{signOutError}</p>}
          <div className="mt-3 flex gap-3">
            {confirming ? (
              <>
                <Button variant="danger" loading={signingOut} onClick={signOutEverywhere}>
                  Yes, sign out everywhere
                </Button>
                <Button variant="secondary" disabled={signingOut} onClick={() => setConfirming(false)}>
                  Cancel
                </Button>
              </>
            ) : (
              <Button variant="secondary" onClick={() => setConfirming(true)}>
                Sign out everywhere
              </Button>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};
